// extracted by mini-css-extract-plugin
module.exports = {"BackLink":"BackLink_BackLink__w7Z23","hidden-md":"BackLink_hidden-md__xuVV2","hidden-lg":"BackLink_hidden-lg__gOWcc","hidden-xl":"BackLink_hidden-xl__Dqr0a"};